import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraKeyValueRow, SpecraPageHeader, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { format } from 'date-fns';
import { DocumentsPanel } from '../../Capture/DocumentsPanel';
import { RfiQuestionsPanel } from '../RfiQuestionsPanel';
import { RfiSourceVersionsPanel } from '../RfiSourceVersionsPanel';
import { useRfiRecord } from './RfiRecordContext';
import { useRfiWorkspaceHome } from './useRfiWorkspaceHome';
/**
 * Notice and attachments (WRT-07 page 4): the existing source-version,
 * documents and question-extraction panels, unchanged, plus the notice facts
 * from the Home read model.
 */ export function RfiNoticePage() {
    const record = useRfiRecord();
    const rfiId = record?.pangaeaId ?? '';
    const { data: home } = useRfiWorkspaceHome(rfiId);
    const n = home?.notice;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-[var(--space-6)] p-[var(--space-6)]",
        "data-testid": Testids.rfiWorkspace.noticePage,
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                title: "Notice and attachments",
                titleSize: "ui"
            }),
            rfiId ? /*#__PURE__*/ _jsx(RfiSourceVersionsPanel, {
                rfiResponseProjectId: rfiId
            }) : null,
            rfiId ? /*#__PURE__*/ _jsx(DocumentsPanel, {
                entityId: rfiId,
                entityType: "rfi_response_project"
            }) : null,
            n?.noticeId ? /*#__PURE__*/ _jsxs("section", {
                className: "flex flex-col gap-[var(--space-1)]",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        title: "Notice",
                        variant: "group"
                    }),
                    /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        label: "Notice ID",
                        value: n.noticeId,
                        variant: "fact"
                    }),
                    /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        label: "Type",
                        value: n.typeLabel || '—',
                        variant: "fact"
                    }),
                    /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        label: "Office",
                        value: n.officeName || '—',
                        variant: "fact"
                    }),
                    /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        label: "Posted",
                        value: n.postedAt ? format(n.postedAt.toDate(), 'd MMM yyyy') : '—',
                        variant: "fact"
                    }),
                    /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        label: "Point of contact",
                        value: n.pointOfContactName || '—',
                        variant: "fact"
                    })
                ]
            }) : null,
            rfiId ? /*#__PURE__*/ _jsx(RfiQuestionsPanel, {
                rfiResponseProjectId: rfiId
            }) : null
        ]
    });
}
